// Healther OPD — SPA entry. Replaces the legacy Babel-in-browser pages.
// shadcn/ui + Tailwind v4 pipeline FIRST so the legacy sheets below cascade
// last and retain priority on any shared selector (the 69 legacy screens must
// render unchanged — see src/styles/shadcn.css header).
import './styles/shadcn.css';
import './styles/opd-ui.css';
import './styles/colors_and_type.css';
// Classic scripts ported as side-effect imports — they attach the globals the
// screens were written against (OPDTheme, HealtherUI, OPDVoice and kiosk guide
// illustrations).
import './lib/theme.js';
import './lib/healther-ui.js';
import './lib/opd-voice.js';
import './lib/guide-illustrations.js';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
// Self-hosted OTA (over-the-air) tablet updates — native-only, no-op on web.
// Kicks the rollback heartbeat + checks our own /ota channel on boot/resume.
import { startOtaUpdates } from './lib/ota.js';

// Capgo 8.50.2 requires this at entry startup, before config/network work. It
// only acknowledges that the downloaded JavaScript bundle initialized; update
// discovery remains deferred and never blocks first paint.
startOtaUpdates();

// Legacy screens reference the React global (React.useState etc.) — keep it
// available while ported modules are migrated incrementally.
window.React = React;

// healther-ui.js auto-renders its own floating EN/हिं pill (top-right) — in
// the SPA every screen listens to the bridge's 'opd:lang' toggle instead, so
// that second pill is a confusing duplicate. Neutralize it.
if (window.HealtherUI) {
  window.HealtherUI.renderLangToggle = () => {};
  document.getElementById('healther-lang-toggle')?.remove();
}

ReactDOM.createRoot(document.getElementById('app')).render(<App />);
